module.exports = {
  messages: {
    CN: {
      desc: '高级表单常见于一次性输入和提交大批量数据的场景。',
      repository: '仓库管理',
      task: '任务管理',
      user: '用户管理',
      submit: '提交'
    },
    HK: {
      desc: '高級表單常見於一次性輸入和提交大批量數據的場景。',
      repository: '倉庫管理',
      task: '任務管理',
      user: '用戶管理',
      submit: '提交'
    },
    US: {
      desc: 'Advanced forms are common in scenarios where large quantities of data are entered and submitted at one time.',
      repository: 'Repository Manage',
      task: 'Task Manage',
      user: 'User Manage',
      submit: 'submit'
    }
  }
}
